<script setup lang="ts">
  import { computed, type PropType } from 'vue';
  import { useRoute } from '@othercommerce/foundation';
  import { selectContentEvent, useGoogleTagManager } from '@storefront/storefront';

  const props = defineProps({
    parent: { type: Object, required: false },
    category: { type: Object, required: false },
    categories: { type: Array as PropType<{ title: string }[]> },
  });

  const route = useRoute();
  const gtm = useGoogleTagManager();

  const back = computed(() => {
    if (props.parent) {
      return route('web.blog.category.show', { category: props.parent });
    } else if (props.category) {
      return route('web.blog.post.index');
    } else {
      return null;
    }
  });
</script>
<template>
  <div class="filters-blog">
    <SfHeading type="h2" id="filters-blog-heading">
      {{ $t('SHOP.BLOG.HEADER.CATEGORIES') }}
    </SfHeading>
    <nav class="filters-blog__content" aria-labelledby="filters-blog-heading">
      <RouterLink v-if="back" :href="back" class="filters-blog__back">
        {{ $t('SHOP.BLOG.ACTION.BACK_TO', { title: parent?.title || $t('SHOP.BLOG.ACTION.BACK_TO_ALL') }) }}
      </RouterLink>
      <ul class="filters-blog__list">
        <li v-for="category in categories">
          <RouterLink @click="gtm.push(selectContentEvent('blogCategory', category.title))" :href='$route("web.blog.category.show", { category })' explicit v-slot="{active}">
            <span :aria-current="active?.value ? 'page' : undefined">
              {{ category.title }}
            </span>
          </RouterLink>
        </li>
      </ul>
    </nav>
  </div>
</template>
<style scoped lang="scss">
  .filters-blog {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    padding: 2rem;
    background: var(--section-background);
    border-inline: var(--section-border-inline);
    border-block: var(--section-border-block);
    border-radius: var(--section-border-radius);

    &__content {
      font-size: 0.875rem;
    }

    &__back {
      display: inline-flex;
      padding-bottom: 0.5rem;
      font-size: 0.875rem;
      font-weight: var(--font-weight-semi);
      text-decoration: underline;
    }

    a {
      padding: 0.25rem 0;
      display: inline-flex;
      text-decoration: underline;
      text-decoration-color: transparent;
      transition: text-decoration-color 0.2s ease-out;


      @media(hover: hover) {
        &:hover {
          text-decoration-color: var(--primary-color);
        }
      }

      &.active {
        font-weight: var(--font-weight-bold);
        color: var(--primary-color);
      }
    }

    &__list {
      list-style: none;
    }

    @media(max-width: 992px) {
      width: 100%;
      padding: 1rem 0.625rem;
      gap: 0.5rem;

      &__list {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 0 1rem;
      }
    }
  }
</style>
